//{{-- docArr is our main data source; when the user adds or removes files, it's all in docArr --}} 
//{{-- It's an array of field objects; each object includes the corresponding file number --}}

//{{-- The create.blade includes various other blades and I've established a scope hirerarchy that must be followed manually: --}}
//{{-- - all locally defined variables (in any of the blades) cannot be referenced outside their local scope; --}}
//{{-- - create.blade can call one or two entry-pont functions in the includes, but the includes --}}
//{{-- ... can only call the Callback functions (and support functions) in create.blade and can never call any functions --}}
//{{-- ... in other includes.  So if an include wants to direct flow to another include, it must call a --}}
//{{-- ... Callback function in create and have that function call the other include. --}}

//{{-- Each file can have multiple target languages, which show as a comma-delimited string on the grid --}}
//{{-- ... because of this there is no one projtype and jobtypes are only calculated (by comparing langs) --}}

//{{-- ... yes, all of these globals are needed --}}
var docArr = [];
var langtoArr = [];
var docDataTable = "";
var descrList = [];

//{{-- ========================================================================================== --}}
//{{-- Scripts directly triggered by form elements                                                --}}
//{{-- ========================================================================================== --}}       
$(function(){
    $('#submitProjectBtn').safeOn('click',function (evt) { //{{-- Processes the submitProjectBtn button click for LOGGED IN USERS --}}                    
        evt.stopImmediatePropagation(); //{{-- Prevent click event triggering once for every parent container --}}
        openProjModal(); //{{-- Opens modal dialog projcreateform --}}
    });
    $('#addfilebtn').safeOn('click',function (evt) {     //{{-- Processes a click on the "add file" button  --}}                  
        evt.stopImmediatePropagation();         //{{-- Prevent click event triggering once for every parent container --}}
        openDocModalForm(checkFile(-1, null));  //{{-- Opens the modal form, indicating a new file number and null file content - openDocModalForm is in docmodalform.blade --}}
    });
});

//{{-- Handle tooltips for anything with the right attribute --}}
$(function(){
    //{{-- Initialize the bootstrap tooltips  --}}
    $('[data-toggle="tooltip"]').tooltip();

    //{{-- As soon as anything with a tooltip is clicked, hide all other tooltips, show only that one --}}
    $('[data-toggle="tooltip"]').on('click', function () {
        var state = $(this).attr('state');
        // Hide all tooltips
        $('[data-toggle="tooltip"]').tooltip('hide');
        // Toggle this tooltip based on its state
        if (state == '0') {
            $(this).tooltip('show');
            $(this).attr('state', '1');
        } else {
            $(this).tooltip('hide');
            $(this).attr('state', '0');
        }
    });
});

//{{-- ============================================================================================ --}}
//{{-- Scripts to handle adding, editing and deleting the Files to/from the dataTable and database  --}}
//{{-- ============================================================================================ --}}       

//{{-- Add a document to docArr and show it on the dataTable  --}}
//{{-- Always called from create.blade.docAddCallback --}}
function addDoc(doc) {
    if (doc) { //{{-- Only if we have data... --}}
        //{{-- Show the datatable division --}}
        $(".home-header-div").hide();
        $('[id="homecarousel-div"]').hide();
        $('[id="docDatatable-div"]').show();
        $('[id="submitProjectBtn-div"]').show();

        //{{-- If there is data on the datatable and user tries to leave, warn him --}}
        $(window).on('beforeunload', function () {
            return cr_if_you_leave_me_now;
        });

        //{{-- Copy the data over to docArr - this is where the data from docmodal actually gets stored somewhere --}}
        //{{-- find filenbr = docNbr in the array --}}
        //{{-- var index = docArr.findIndex(function(docArr) {return docArr["filenbr"] === doc.filenbr} );     --}}
        var index = myFindIndex(docArr, "filenbr", doc.filenbr); //{{-- IE doesn't support array.findIndex, so we implement our own - in main.blade --}}
        if (index < 0) {
            docArr.push(doc); //{{-- We're saving a new document --}}
        } else {
            docArr[index] = doc; //{{-- We're saving an existing document --}}
        }

        //{{-- Refresh the datatable based on docArr - this is where the grid is shown for the first time --}}
        docDataTableRefresh($("#tablediv"), docArr, false); //{{-- docDataTableRefresh is in docdatatable.blade --}}
        calcTotalPrice();
        showEditToCompleteDiv();
    }
};

//{{-- This is called from docdatatable.blade when the user clicks on the "Edit" icon on a line on the grid --}}
//{{-- It finds the doc (by number) in docArr and opens the doc modal form for editing --}}
window.fileEditCallback = function(docNbr) {
    var doc = docArr.find(function (docArr) {
        return docArr["filenbr"] === docNbr
    }); //{{-- find filenbr = docNbr in docArr, returns the entire element --}}
    openDocModalForm(checkFile(docNbr, doc));       //{{-- Opens the modal form, to edit the file found - openDocModalForm is in docmodalform.blade --}}
};

//{{-- This is called from docdatatable.blade when the user clicks on the "Delete" icon on a line on the grid --}}
//{{-- It deletes a file from docArr refreshes the datable --}}
window.fileDeleteCallback = function(docNbr) {
    //{{-- Find the element in file Arr --}}
    //{{-- find filenbr = docNbr in docArr --}}
    //{{-- var index = docArr.findIndex(function(docArr) {return docArr["filenbr"] === docNbr} ); --}}
    var index = myFindIndex(docArr, "filenbr", docNbr); //{{-- IE doesn't support array.findIndex, so we implement our own - in main.blade --}}

    //{{-- Drop the file from docArr --}}
    if (index > -1) docArr.splice(index, 1);
    //{{-- Refresh the datatable  --}}
    docDataTableRefresh($("#tablediv"), docArr, false); //{{-- docDataTableRefresh is in docdatatable.blade  --}}
    calcTotalPrice();
    //{{-- If we are all out of files, hide the docdatatable div; if not, check if we need to show the "click edit to complete the data" division --}}
    if (!docArr || docArr.length < 1) {
        $("#editToCompleteMsg").hide();
        $('[id="docDatatable-div"]').hide();
        $('[id="submitProjectBtn-div"]').hide();
        $(".home-header-div").show();
        $('[id="homecarousel-div"]').show();
        //{{-- If the table is empty, don't pester the user with messages --}}
        $(window).off('beforeunload');
    } else {
        showEditToCompleteDiv();
    }
};

//{{-- This is called from filedropform.blade - it's the callback function for jquery file upload "upload done"  --}}
//{{-- This gets called once for each file uploaded --}}
window.uploadDoneCallback = function(fileNbr, resultFile, fileSize) {
    //{{-- Now we have to keep track of each uploaded file, this is done in projcreateform.blade --}}
    trackUploads(fileNbr, resultFile, fileSize);
}

//{{-- This is called from projcreateform.blade to prepare documents data for saving --}}
//{{-- docsToSaveArr is really pjc_DocArr, which in turn is really docArr, but we pass them along as parameters anyway... --}}
//{{-- Arrays ('cause they're objects) in Javascript are passed by "call by sharing", which means they are passed by reference, you just can't overwrite (destroy) them completely, but you can change their contents --}}
//{{-- prepDocuments() is in docdatatable.blade --}}
window.prepDocumentsCallback = function(docsToSaveArr, projstatus) {
    return prepDocuments(docsToSaveArr, projstatus);
}

//{{-- Shows or hides the "Click edit to complete the data" division--}}
function showEditToCompleteDiv() {
    //{{-- Check that docArr isn't empty --}}
    allValid = false;
    if (!docArr || docArr.length > 0) {
        //{{-- Then make sure all documents on the list have been validated --}}
        invalidRow = docArr.find(function (docArr) {
            return !docArr["validated"]
        });
        allValid = notThere(invalidRow);
    }
    //{{-- Show or hide the Edit To Complete div accordingly --}}
    if (allValid) {
        $("#editToCompleteMsg").hide();
        $("#submitProjectBtn-div").show();
    } else {
        $("#editToCompleteMsg").show();
        $("#submitProjectBtn-div").hide();
    }
}

//{{-- ========================================================================================== --}}
//{{-- Scripts to handle creating new files in docArr and then                                    --}}
//{{-- opening DOCMODALFORM or adding the file to the Data Table                                  --}}
//{{-- ========================================================================================== --}}

//{{-- Callback from filedropform when a (each) file is added to the queue - fi.on(fileuploadadd) --}}
//{{-- Does everything we need to do with the file, but most notably: adds it to docArr! --}}
//{{-- Although this is called once for each file, fcount can be > 1, indicating multiple files were dropped into the dropzone, and will be processed one by one  --}}
//{{-- Note that here docNbr is always -1 and doc is always null --}}
//{{-- fileData comes from blueimp's file upload in filedropform and may be null, if there's no real file for the user's file  --}}
window.fileUploadAddCallback = function(fcount, docNbr, doc, fname, ftype, fsize, fileData) {
    if (fcount < 2) {
        //{{-- If it's not open already, open docmodalform with the file info (and send the file data) --}}
        if (!($('#modalAddFile').data('bs.modal') || {
                _isShown: false
            })._isShown) {
                openDocModalForm(checkFile(docNbr, doc, fname, ftype, fsize, fileData)); //{{-- openDocModalForm is in docmodalform.blade --}}
        } else {
            //{{-- If docmodal form is already open, update docArr, file name, type and data there - and send the file data - updateDocModalFile is here in docmodalform --}}
            updateDocModalFile(fname, ftype, fsize, fileData);
        }
    } else {
        //{{-- Insert each file into the filedatatable and docArr - docAddCallback is in create.blade --}}
        docAddCallback(docNbr, doc, fname, ftype, fsize, fileData);
    }
}

//{{-- Called from docmodalform when the user clicks on "save" and all the fields are OK --}}
//{{-- Called from fileUploadAddCallback when the user drops in multiple files --}}
//{{-- Adds the file into docArr and inserts it into the dataTable --}}
//{{-- fileData comes from blueimp's file upload in filedropform and may be null, if there's no real file for the user's file  --}}       
window.docAddCallback = function(docNbr, doc, fname, ftype, fsize, fileData) {
    addDoc(checkFile(docNbr, doc, fname, ftype, fsize, fileData)); //{{-- addDoc is here in create.blade --}}                      
}

//{{-- Callback from filedropform for when the file box is clicked. In our case, we want to open docModalForm for a new file --}}
window.fileBoxClickCallback = function(boxId) {
    tier_desc = boxId.split('_')[1];
    if (tier_desc == 'economy') {
        tier = 0;
        openDocAutoTransModal(checkFile(-1, null), tier);       //{{-- openDocAutoTransModal is in docautotrans.blade - Opens the modal form, indicating a new file number and null file content --}}
    } else if (tier_desc == 'professional') {
        tier = 1;
        openDocModalForm(checkFile(-1, null), tier);            //{{-- openDocModalForm is in docmodalform.blade - Opens the modal form, indicating a new file number and null file content --}}
    } else if (tier_desc == 'premium') {
        tier = 2;
        openDocModalForm(checkFile(-1, null), tier);            //{{-- openDocModalForm is in docmodalform.blade - Opens the modal form, indicating a new file number and null file content --}}
    }
}

//{{-- Makes sure we have a file object with data or a new file object --}}
function checkFile(docNbr, file, fname, ftype, fsize, fileData) {
    //{{-- If we didn't get a file, make a new one with the given parameters --}}
    if (typeof file === 'undefined' || !file) {
        file = getNewFileObj(docNbr, fname, ftype, fsize, fileData);
    } else {
        //{{-- if we did get a file and a fileData param, make sure fileData is up to date --}}
        if (typeof fileData != 'undefined') {
            file.fileData = fileData;
        }
    }
    return file;
}

function getNewFileObj(docNbr, fname, ftype, fsize, fileData) {
    //{{-- If docNbr is negative, it means we need a new docNbr, so find the largest value of filenbr in docArr --}}
    if (docNbr < 0) {
        docNbr = -1; //{{-- need to make sure it's -1 --}}
        docArr.forEach(function (docArrElem) {
            docNbr = Math.max(docNbr, docArrElem["filenbr"]);
        });
        docNbr++;
    }
    //{{-- If we didn't get the file's name or type, make sure they default to blank: --}}
    if (!fname || (typeof fname === 'undefined') || !ftype || (typeof fname === "undefined")) {
        fname = "";
        ftype = "";
    }
    //{{-- Make the new file object: --}}
    file = {
        filenbr: docNbr,
        fileData: fileData,
        filename: fname,
        jobtype: "", //{{-- TODO: jobtype is not used and can be taken out --}}
        doctype: ftype,
        characters: "",
        words: "",
        counttype: "chars",
        videotype: "", //{{-- videotype, on the other hand, needs to stay --}}
        minutes: "",
        duedate: "",
        duetime: "18:00",
        langfrom: "",
        langto: [],
        langtoPrices: [], //{{-- tier prices for each langto, as [[priceT0,priceT1,priceT2,priceT3],[priceT0,priceT1,priceT2,priceT3]}...] - indexed by langto id --}}
        tierTotalPrices: [0, 0, 0], //{{-- total (sum) prices for T1, T2, T3 --}}
        tier: "",
        original_path: "",
        final_path: "",
        file_size: fsize,
        validated: false,
    };
    return file;
}

//{{-- ========================================================================================== --}}
//{{-- Scripts to handle PRICE CALCULATION                                                        --}}
//{{-- ========================================================================================== --}}

//{{-- Calculates the total price shown on screen, from docArr --}}
function calcTotalPrice() {
    if (docArr.length === 0) {
        $("#totalprice").val(formatNbr(0));
        $("#totalprice-div").hide();
    } else {
        var total = 0;
        $.each(docArr, function (index, doc) {
            if (doc.validated) {
                total += doc["tierTotalPrices"][doc["tier"]];
            }
        });
        $("#totalprice").val(formatNbr(total));
        $("#totalprice-div").show();
    }
}

//{{-- ========================================================================================== --}}
//{{-- Scripts to handle opening Modal projcreateform.blade                                       --}}
//{{-- ========================================================================================== --}}
function openProjModal() {
    //{{-- First make sure all documents in docArr are validated and have real files --}}
    if (!docArr || docArr.length < 1) {
        alert(cr_project_has_no_docs); //{{-- This should never happen, as the Send Project button is only shown at the bottom of the file grid --}}
    } else {
        //{{-- Then make sure all documents on the list have been validated --}}
        var invalidRow = docArr.find(function (docArr) {
            return !docArr["validated"]
        });
        var allValid = notThere(invalidRow);
        if (!allValid) {
            alert(cr_pls_complete_docs);
        } else {
            //{{-- Then make sure every line on the grid has its own real file --}}
            var noSelectRow = docArr.find(function (docArr) {
                return docArr["filename"] === cr_no_file_paren
            });
            var noDataRow = docArr.find(function (docArr) {
                return notThere(docArr["fileData"])
            });
            var allHaveFiles = notThere(noSelectRow) & notThere(noDataRow);
            if (!allHaveFiles) {
                alert(cr_pls_attach_files);
            } else {
                //{{-- Then make sure total price has been calculated --}}
                var totalCost = $("#totalprice").val();
                if (!totalCost) {
                    alert(cr_pls_select_price); //{{-- This should never happen --}}
                } else {
                    //{{-- Finally, we're clear to open projecreateform --}}
                    openProjModalForm(docArr, totalCost); //{{-- Opens modal dialog projcreateform --}}
                }
            }
        }
    }
}